<template>
  <div style="position: relative; width: 170px; display: inline-block;">
    <v-text-field
      v-model="value._value"
      :label="value.name"
      hide-details="auto"
      filled
      dense
      :suffix="suffix"
      :disabled="!value.isActive"
      :background-color="isNumber(value._value) ? '' : '#f0dde0'"
    >
    </v-text-field>
    <v-checkbox
      v-model="value.isActive"
      style="position: absolute; top: -15px; right: 0px;"
    ></v-checkbox>
  </div>
  
</template>

<script>
export default {
  name: 'room-selector',
  
  props: {
    value: Object,
    suffix: String
  },
  
  data() {
    return {
      input: null
    }
  },

  created() {
    
  },
  
  watch: {
    ['value.isActive'](newVal) {
      if (newVal) {
        this.value.value = this.value.default;
        this.value._value = this.value.default;
        this.$emit('activated');
      } else {
        this.value.value = 0;
        this.value._value = 0;
      }
    },
    ['value._value'](newVal) {
      if (this.isNumber(newVal)) {
        this.value.value = newVal;
        this.$emit('changed');
      }
    }
  },

  methods: {
    
  }
}
</script>